<template>
  <div class="pubdetail-header-subsection">
    <div class="navigation-bar">
      <div class="navbar">
        <div class="link" @click="go('/')">首页</div>
        <div class="link" @click="go('/about')">关于云帆</div>
        <div class="link" @click="go('/course')">课程体系</div>
        <div class="link" @click="go('/pub')">云帆公告</div>
        <div class="link" @click="go('/zhaoping')">招贤纳士</div>
      </div>
      <img class="logo" alt="Logo" :src="logoSrc" />
      <img class="underline" alt="Underline" :src="rectSrc" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PubDetailHeaderSubsection",
  props: {
    logoSrc: { type: String, default: "/static/img/pubdetail-wecom-temp@2x.png" },
    rectSrc: { type: String, default: "/static/img/pubdetail-rectangle-148359.svg" },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.pubdetail-header-subsection { display: flex; justify-content: center; width: 100%; }
.navigation-bar { background-color: #ffffff; box-shadow: inset 0 -1px 0 #dee1e2; height: 99px; position: relative; width: 1920px; }
.navbar { align-items: center; display: inline-flex; gap: 64px; left: calc(50% + 169px); position: absolute; top: calc(50% - 14px); }
.link { color: #000000; font-family: "PingFang SC-Medium", Helvetica; font-size: 18px; font-weight: 500; line-height: 27px; white-space: nowrap; cursor: pointer; }
.logo { height: 64px; left: 180px; position: absolute; top: 18px; width: 167px; object-fit: cover; }
.underline { height: 4px; left: 1522px; position: absolute; top: 68px; width: 30px; }
</style>